import { defineComponent } from "vue";
import MessageClientChatPacket from "../packets/client/MessageClientChatPacket";

export default defineComponent({
    template: `
        <div class="livechat__text">
            <form class="livechat__text-form">
                <textarea class="livechat__textinput" :placeholder="entermessage" v-model.trim="text" v-on:keydown.enter.prevent="onMessage" ref="text"></textarea>

                <button type="button" class="livechat__send livechat-button" @click="onMessage" :disabled="sending"><i class="fa fa-share"></i></button>
            </form>
        </div>
    `,

    emits: [
        'update:sending',
    ],

    props: {
        user: { type: Object, required: true },
        options: { type: Object, required: true },
        sending: { type: Boolean },
    },

    data() {
        return {
            text: null,
        };
    },

    computed: {
        entermessage() {
            return this.options.i18n.entermessage + ' ' + this.user.username;
        },
    },

    methods: {
        async onMessage() {
            if (this.sending) {
                return;
            }

            const text: string = this.text;

            if (!text.length) {
                return;
            }

            this.$emit('update:sending', true);

            this.text = null;

            await this.$root.sendPacket(new MessageClientChatPacket(text));

            this.$emit('update:sending', false);

            $(this.$refs.text).focus();
        },
    },
});
